import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { SagaConfig } from '@sagas/request/types';

import { type RolesState } from './types';

export const initialState: RolesState = {
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
  model: {},
};

export const rolesRequest = createAction<{ sagaConfig?: SagaConfig }>('roles/request');

const roles = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
  extraReducers: builder => {
    builder.addCase(rolesRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
  },
});

export const { reset: rolesReset, success: rolesSuccess, failure: rolesFailure } = roles.actions;

export default roles.reducer;
